import {
  BarIcon,
  IconArrowDown,
  IconCalendar,
  IconRemoved,
  Iconreview,
  IconTable,
  IconTimeline,
  IconToDo,
  Imgcompleted,
  Imgprogress,
  Imgstatus,
} from 'src/components/Icons';
import i18n from 'i18next';
import { Checkbox, Tag } from 'antd';
import { StatusTaskReport } from './enum';

const constants = {
  AXIOS: {
    HTTP_STATUS: {
      FORBIDDEN: 403,
      UNAUTHORIZED: 401,
      BAD_REQUEST: 400,
      SUCCESS: 200,
    },
  },
  USER_LIST_URL: `/system/member2`,
  DEPT_LIST_URL: `/system/department`,
  PROJECT_URL: `/project/overview/`,
  PROJECT_TASK_URL: `/project/task/`,
  DASHBOARD_URL: `/dashboard`,
  PROJECT_LIST_URL: `/project/manager`,
  DASHBOARD_OVERVIEW_URL: `/dashboard/manager/project`,
  TASK_LIST_URL: `/task/my-task/filter/task`,
  ASSIGNED_TASK_LIST_URL: `/task/my-task/filter/assign`,
  //
  BASE_SERVICE_URL: `${process.env.REACT_APP_API_URL}`,
  STATE_URL_BEFORE_LOGIN: 'stateURLBeforeLogin',
  MESSAGE_DURATION: 5,
  STORAGE_KEY: {
    ROLE_CODE: 'roleCode',
    DEPT_CODE: 'deptCoe',
    TOKEN_DATA: 'tokenData',
  },
  COUNTDOWN_LOGOUT_DURATION: 5,
  PROJECT_DAYS_BEFORE_ENDDATE: 7,
  WARNING_DAYS: 7,
  START_COUNT_DAYS: 30,

  FORMAT_DATE_TIME: 'DD/MM/YYYY',
  FORMAT_DATE_MONTH: 'DD/MM',
  FORMAT_DATE_MONTH_YEAR: 'MM/YYYY',
  FORMAT_DATE_YEAR: 'YYYY',
  FORMAT_DATE_TIME_WITH_HOUR: 'HH:mm DD/MM/YYYY',
  FORMAT_DATE_TIME_WITH_WEEKDAY: 'dddd DD/MM/YYYY',
  MAX_CHARACTERS: 50,
  FETCH_STATUS: {
    IDLE: 'idle',
    LOADING: 'loading',
    READY: 'ready',
  },
  TASK: {
    STATUS_ASSIGNER_EDITABLE: [
      'draft',
      'wait_confirm',
      'processing',
      'wait_done',
    ],
    STATUS_ASSIGNER_DELETEABLE: [
      'wait_confirm',
      'processing',
      'wait_done',
    ],
    STATUS_ASSIGNER_CANCELABLE: [
      'wait_confirm',
      'processing',
      'wait_done',
    ],
    STATUS_ASSIGNED_EDITABLE: [
      'draft',
      'wait_confirm',
      'processing',
    ],
    STATUS_ASSIGNED_DELETEABLE: ['draft', 'wait_confirm'],
    STATUS_ASSIGNED_CANCELABLE: [
      'draft',
      'wait_confirm',
      'processing',
    ],
  },
  STATUS_CODE: {
    DRAFT: 'draft',
    WAIT_CONFIRM: 'wait_confirm',
    PROCESSING_NOLATE: 'processing_nolate',
    PROCESSING: 'processing',
    WAIT_DONE: 'wait_done',
    NO_DONE: 'no_done',
    DONE: 'done',
    DONE_NOLATE: 'done_nolate',
    DONE_LATE: 'done_late',
    LATE: 'late',
    CANCEL: 'cancel',
  },
  ITEM_STATUS: [
    { code: 'active', name: 'Hoạt động', color: 'green' },
    {
      code: 'inactive',
      name: 'Không hoạt động',
      color: 'red',
    },
  ],
  STATUS: [
    // {
    //   code: 'draft',
    //   desc: i18n.t('task.status.draft'),
    //   bg: 'rgb(230, 230, 230)',
    //   color: '#666666',
    // },
    // {
    //   code: 'wait_confirm',
    //   desc: i18n.t('task.status.wait_confirm'),
    //   bg: 'rgba(255, 153, 0, 0.1)',
    //   color: '#FF9900',
    // },
    {
      code: 'processing',
      desc: i18n.t('task.status.processing'),
      bg: 'rgba(0, 169, 222, 0.1)',
      color: '#00A9DE',
    },
    {
      code: 'wait_done',
      desc: i18n.t('task.status.wait_done'),
      bg: 'rgba(0, 90, 196, 0.1)',
      color: '#005AC4',
    },
    {
      code: 'done',
      desc: i18n.t('task.status.done'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#00C48C',
    },
    {
      code: 'cancel',
      desc: i18n.t('task.status.cancel'),
      bg: 'rgba(221, 0, 0, 0.1)',
      color: '#DD0000',
    },
  ],
  REPORT_STATUS: [
    // CongPPT 2026-01-30: Off cột Từ chối duyệt thực hiện & Chờ duyệt thực hiện trong báo cáo tổng hợp
    // {
    //   code: 'draft',
    //   desc: i18n.t('task.status.draft'),
    //   bg: 'rgb(230, 230, 230)',
    //   color: '#666666',
    //   type: StatusTaskReport.REJECT,
    // },
    // {
    //   code: 'wait_confirm',
    //   desc: i18n.t('task.status.wait_confirm'),
    //   bg: 'rgba(255, 153, 0, 0.1)',
    //   color: '#FF9900',
    //   type: StatusTaskReport.PENDING_WORK,
    // },
    {
      code: 'processing_nolate',
      desc: i18n.t('task.status.processing'),
      bg: 'rgba(0, 169, 222, 0.1)',
      color: '#00A9DE',
      type: StatusTaskReport.PROCESSING,
    },
    {
      code: 'wait_done',
      desc: i18n.t('task.status.wait_done'),
      bg: 'rgba(0, 90, 196, 0.1)',
      color: '#005AC4',
      type: StatusTaskReport.WAITING_COMPLETE,
    },
    {
      code: 'done',
      desc: i18n.t('task.status.done'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#00C48C',
      type: StatusTaskReport.COMPLETE,
    },
    {
      code: 'late',
      desc: i18n.t('task.status.late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#DD0000',
      type: StatusTaskReport.OVERDUE,
    },
  ],
  PROJECT_STATUS_CODE: {
    PROCESSING: 'processing',
    NEARING_COMPLETION: 'nearing_completion',
    DONE: 'done',
    DONE_ONTIME: 'done_ontime',
    LATE: 'late',
  },
  PROJECT_STATUS: [
    {
      code: 'processing',
      name: i18n.t('project.status.processing'),
      bg: 'rgba(0, 169, 222, 0.1)',
      color: '#00A9DE',
    },
    {
      code: 'nearing_completion',
      name: i18n.t('project.status.nearing_completion'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#FF9900',
    },
    {
      code: 'done',
      name: i18n.t('project.status.done'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#00C48C',
    },
    {
      code: 'late',
      name: i18n.t('project.status.late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#DD0000',
    },
  ],
  REPORT_DEPT_TASK_STATUS: [
    {
      code: 'processing',
      desc: i18n.t('task.status.processing'),
      bg: 'rgba(0, 169, 222, 0.1)',
      color: '#00A9DE',
    },
    {
      code: 'done',
      desc: i18n.t('task.status.done'),
      bg: 'rgba(0, 90, 196, 0.1)',
      color: '#00C48C',
    },
    {
      code: 'wait_done',
      desc: i18n.t('task.status.wait_done'),
      bg: 'rgba(0, 90, 196, 0.1)',
      color: '#005AC4',
    },
    {
      code: 'late',
      desc: i18n.t('task.status.late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#DD0000',
    },
  ],
  REPORT_HOME_STATUS_MANAGER: [
    // luan.nguyenxuan - 29/01/2026 - off phê duyệt thực hiện
    // {
    //   code: 'wait_confirm',
    //   desc: i18n.t('task.status.wait_confirm_manager'),
    //   bg: 'rgba(255, 153, 0, 0.1)',
    //   color: '#FF9900',
    // },
    {
      code: 'processing',
      desc: i18n.t('task.status.processing'),
      bg: 'rgba(0, 169, 222, 0.1)',
      color: '#00A9DE',
    },
    {
      code: 'wait_done',
      desc: i18n.t('task.status.wait_done_manager'),
      bg: 'rgba(0, 90, 196, 0.1)',
      color: '#005AC4',
    },
    {
      code: 'late',
      desc: i18n.t('task.status.late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#DD0000',
    },
    // luan.nguyenxuan - 29/01/2026 - off từ chối duyệt thực hiện
    // {
    //   code: 'draft',
    //   desc: i18n.t('task.status.draft'),
    //   bg: 'rgb(230, 230, 230)',
    //   color: '#A7A7A7',
    // },
  ],
  REPORT_HOME_STATUS_MEMBER: [
    // luan.nguyenxuan - 29/01/2026 - off phê duyệt thực hiện
    // {
    //   code: 'wait_confirm',
    //   desc: i18n.t('task.status.wait_confirm'),
    //   bg: 'rgba(255, 153, 0, 0.1)',
    //   color: '#FF9900',
    // },
    {
      code: 'processing',
      desc: i18n.t('task.status.processing'),
      bg: 'rgba(0, 169, 222, 0.1)',
      color: '#00A9DE',
    },
    {
      code: 'wait_done',
      desc: i18n.t('task.status.wait_done'),
      bg: 'rgba(0, 90, 196, 0.1)',
      color: '#005AC4',
    },
    {
      code: 'late',
      desc: i18n.t('task.status.late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#DD0000',
    },
    // luan.nguyenxuan - 29/01/2026 - off từ chối duyệt thực hiện
    // {
    //   code: 'draft',
    //   desc: i18n.t('task.status.draft'),
    //   bg: 'rgb(230, 230, 230)',
    //   color: '#A7A7A7',
    // },
  ],
  REPORT_TASK_STATUS: [
    // {
    //   code: 'draft',
    //   desc: i18n.t('task.status.draft'),
    //   bg: 'rgba(255, 153, 0, 0.1)',
    //   color: '#FF9900',
    // },
    {
      code: 'wait_confirm',
      desc: i18n.t('task.status.wait_confirm'),
      bg: 'rgba(255, 153, 0, 0.1)',
      color: '#FF9900',
    },
    {
      code: 'processing',
      desc: i18n.t('task.status.processing'),
      bg: 'rgba(0, 169, 222, 0.1)',
      color: '#00A9DE',
    },
    {
      code: 'wait_done',
      desc: i18n.t('task.status.wait_done'),
      bg: 'rgba(0, 90, 196, 0.1)',
      color: '#005AC4',
    },
    {
      code: 'done',
      desc: i18n.t('task.status.done_ontime'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#00C48C',
    },
    {
      code: 'done_late',
      desc: i18n.t('task.status.done_late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#99C48C',
    },
    {
      code: 'late',
      desc: i18n.t('task.status.late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#DD0000',
    },
  ],
  REPORT_TASK_NO_APPROVAL_STATUS: [
    {
      code: 'processing',
      desc: i18n.t('task.status.processing'),
      bg: 'rgba(0, 169, 222, 0.1)',
      color: '#00A9DE',
    },
    {
      code: 'done',
      desc: i18n.t('task.status.done_ontime'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#00C48C',
    },
    {
      code: 'done_late',
      desc: i18n.t('task.status.done_late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#99C48C',
    },
    {
      code: 'late',
      desc: i18n.t('task.status.late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#DD0000',
    },
  ],
  REPORT_HOME_TASK_STATUS: [
    {
      code: 'done',
      desc: i18n.t('task.status.done_ontime'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#00C48C',
    },
    {
      code: 'processing',
      desc: i18n.t('task.status.processing'),
      bg: 'rgba(0, 169, 222, 0.1)',
      color: '#00A9DE',
    },
    {
      code: 'wait_done',
      desc: i18n.t('task.status.wait_done'),
      bg: 'rgba(0, 90, 196, 0.1)',
      color: '#005AC4',
    },
    {
      code: 'done_late',
      desc: i18n.t('task.status.done_late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#99C48C',
    },
    {
      code: 'late',
      desc: i18n.t('task.status.late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#DD0000',
    },
  ],
  REPORT_PROJECT_TASK_STATUS: [
    {
      code: 'done',
      desc: i18n.t('task.status.done_ontime'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#00C48C',
    },
    {
      code: 'done_late',
      desc: i18n.t('task.status.done_late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#99C48C',
    },
    {
      code: 'late',
      desc: i18n.t('task.status.late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#DD0000',
    },
    {
      code: 'wait_done',
      desc: i18n.t('task.status.wait_done'),
      bg: 'rgba(0, 90, 196, 0.1)',
      color: '#005AC4',
    },
  ],
  TODO_STATUS: [
    // {
    //   code: 'draft',
    //   desc: i18n.t('task.status.draft'),
    //   bg: 'rgb(230, 230, 230)',
    //   color: '#A7A7A7',
    //   checkbox: (
    //     <IconToDo
    //       className="img-status"
    //       width={21}
    //       height={21}
    //     />
    //   ),
    //   tag: (
    //     <Tag
    //       style={{ marginTop: 5 }}
    //       color="#A7A7A7"
    //       className="!text-[#1C274C] w-fit !rounded-xl !flex !items-center gap-1"
    //     >
    //       {
    //         i18n.t('task.status.draft')
    //       }
    //     </Tag>
    //   )
    // },
    // {
    //   code: 'wait_confirm',
    //   desc: i18n.t('task.status.wait_confirm'),
    //   bg: 'rgba(255, 153, 0, 0.1)',
    //   color: '#FF9900',
    //   checkbox: <Imgstatus className="img-status" />,
    //   tag: (
    //     <Tag
    //       style={{ marginTop: 5 }}
    //       color="#FF9900"
    //       className="!text-[#1C274C] w-fit !rounded-xl !flex !items-center gap-1"
    //     >
    //       {
    //         i18n.t('task.status.wait_confirm')
    //       }
    //     </Tag>
    //   )
    // },
    {
      code: 'processing',
      desc: i18n.t('task.status.processing'),
      bg: 'rgba(0, 169, 222, 0.1)',
      color: '#00A9DE',
      checkbox: <Imgprogress className="img-status" />,
      tag: (
        <Tag
          style={{ marginTop: 5 }}
          color="#00A9DE"
          className="!text-[#ffffff] w-fit !rounded-xl !flex !items-center gap-1"
        >
          {
            i18n.t('task.status.processing')
          }
        </Tag>
      )
    },
    {
      code: 'wait_done',
      desc: i18n.t('task.status.wait_done'),
      bg: 'rgba(0, 90, 196, 0.1)',
      color: '#005AC4',
      checkbox: <Iconreview className="img-status" />,
      tag: (
        <Tag
          style={{ marginTop: 5 }}
          color="#005AC4"
          className="!text-[#ffffff] w-fit !rounded-xl !flex !items-center gap-1"
        >
          {
            i18n.t('task.status.wait_done')
          }
        </Tag>
      )
    },
    {
      code: 'done',
      desc: i18n.t('task.status.done'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#00C48C',
      checkbox: <Imgcompleted className="img-status" />,
      tag: (
        <Tag
          style={{ marginTop: 5 }}
          color="#00C48C"
          className="!text-[#ffffff] w-fit !rounded-xl !flex !items-center gap-1"
        >
          {
            i18n.t('task.status.done')
          }
        </Tag>
      )
    },
    {
      code: 'cancel',
      desc: i18n.t('task.status.cancel'),
      bg: 'rgba(221,0,0,0.1)',
      color: '#DD0000',
      checkbox: (
        <IconRemoved
          width={21}
          height={21}
          className="img-status"
        />
      ),
      tag: (
        <Tag
          style={{ marginTop: 5 }}
          color="#DD0000"
          className="!text-[#ffffff] w-fit !rounded-xl !flex !items-center gap-1"
        >
          {
            i18n.t('task.status.cancel')
          }
        </Tag>
      )
    },
  ],
  TODO_NO_APPROVAL_STATUS: [
    {
      code: 'processing',
      desc: i18n.t('task.status.processing'),
      bg: 'rgba(0, 169, 222, 0.1)',
      color: '#00A9DE',
      checkbox: <Imgprogress className="img-status" />,
    },
    {
      code: 'done',
      desc: i18n.t('task.status.done'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#00C48C',
      checkbox: <Imgcompleted className="img-status" />,
    },
  ],
  HISTORY_ACTIONS: [
    {
      code: 1,
      name: i18n.t('history_actions.create'),
      icon: 'fas fa-plus',
    },
    {
      code: 2,
      name: i18n.t('history_actions.update'),
      icon: 'fas fa-pen',
    },
    {
      code: 3,
      name: i18n.t('history_actions.delete'),
      icon: 'fas fa-trash',
    },
    {
      code: 4,
      name: i18n.t('history_actions.add'),
      icon: 'fas fa-plus',
    },
    {
      code: 5,
      name: i18n.t('history_actions.edit'),
      icon: 'fas fa-pen',
    },
    {
      code: 6,
      name: i18n.t('history_actions.status'),
      icon: 'fas fa-pen',
    },
    {
      code: 7,
      name: i18n.t('history_actions.task_confirm'),
      icon: 'fas fa-pen',
    },
    {
      code: 8,
      name: i18n.t('history_actions.task_done'),
      icon: 'fas fa-pen',
    },
    {
      code: 9,
      name: i18n.t('history_actions.setting'),
      icon: 'fas fa-pen',
    },
  ],
  NOTIFICATION_ACTION: [
    {
      code: 'created',
      desc: i18n.t('notification.actions.created'),
    },
    {
      code: 'updated',
      desc: i18n.t('notification.actions.updated'),
    },
    {
      code: 'deleted',
      desc: i18n.t('notification.actions.deleted'),
    },
  ],
  NOTIFICATION_FUNCTION: [
    {
      code: 'role',
      desc: i18n.t('notification.functions.role'),
    },
    {
      code: 'team',
      desc: i18n.t('notification.functions.team'),
    },
    {
      code: 'project',
      desc: i18n.t('notification.functions.project'),
    },
    {
      code: 'task',
      desc: i18n.t('notification.functions.task'),
    },
  ],
  APPROVAL: [
    {
      code: 0,
      desc: i18n.t('approval.no'),
    },
    {
      code: 1,
      desc: i18n.t('approval.yes'),
    },
  ],
  PROJECT_TYPE_KEY: {
    IN: '1',
    OUT: '2',
  },
  PROJECT_TYPE: [
    {
      code: '1',
      desc: i18n.t('project.type.in'),
    },
    {
      code: '2',
      desc: i18n.t('project.type.out'),
    },
  ],
  LABEL: [
    {
      code: 'isUrgent',
      desc: i18n.t('task.label.isUrgent'),
      bg: 'rgba(221, 0, 0, 0.1)',
      color: '#DD0000',
    },
  ],
  DAYSLEFT: [
    {
      code: 1,
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#00C48C',
    },
    {
      code: 2,
      bg: 'rgba(255, 153, 0, 0.1)',
      color: '#FF9900',
    },
    {
      code: 3,
      bg: 'rgba(221, 0, 0, 0.1)',
      color: '#DD0000',
    },
  ],

  SETTING_SELECT: {
    filterOption: true,
    optionFilterProp: 'children',
    showSearch: true,
    allowClear: true,
    showArrow: true,
    // dropdownMatchSelectWidth: false,
  },
  SETTING_SELECT_MULTI: {
    filterOption: true,
    optionFilterProp: 'children',
    showSearch: true,
    allowClear: true,
    showArrow: true,
    // dropdownMatchSelectWidth: false,
    mode: 'multiple' as any,
  },
  NOTICE_FILTER: [
    {
      label: 'Tất cả',
      value: '',
      icon: <IconCalendar />,
    },
    {
      label: 'Hôm nay',
      value: '1',
      icon: <IconCalendar />,
    },
    {
      label: 'Tuần này',
      value: '2',
      icon: <IconCalendar />,
    },
  ],
  LIST_FILTER: [
    {
      title: 'Bảng',
      icon: <IconTable />,
    },
    {
      title: 'List',
      icon: <BarIcon height={10} width={16} />,
    },
  ],
  LIST_GRID: [
    {
      title: 'List',
      icon: <BarIcon height={10} width={16} />,
      iconAffter: <IconArrowDown />,
    },
    {
      title: 'Lưới ',
      icon: <IconTable />,
    },
  ],
  LIST_FILTER_MULTIPLE: [
    {
      title: 'List',
      icon: <BarIcon height={10} width={16} />,
      iconAffter: <IconArrowDown />,
    },
    {
      title: 'Bảng',
      icon: <IconTable />,
    },
    {
      title: 'Lịch',
      icon: <IconCalendar />,
    },
    {
      title: 'Timeline',
      icon: <IconTimeline size={14} color={`959595`} />,
    },
  ],
  LIST_FILTER_ASSIGN: [
    {
      title: 'Giao',
    },
    {
      title: 'Được giao',
    },
  ],
  TASK_SORT: [
    {
      label: 'Ưu tiên cao nhất',
      value: 'priority,asc',
      icon: 'far fa-chevron-double-up',
    },
    {
      label: 'Ưu tiên thấp nhất',
      value: 'priority,desc',
      icon: 'far fa-chevron-double-down',
    },
    {
      label: 'Ngày kết thúc',
      value: '',
      icon: 'far fa-clock',
    },
  ],
  TASK_PRIORITY: [
    {
      label: 'Ưu tiên cao',
      value: 1,
      icon: 'fas fa-chevron-double-up',
    },
    {
      label: 'Trung bình',
      value: 2,
      icon: 'fas fa-grip-lines',
    },
    {
      label: 'Ưu tiên thấp',
      value: 3,
      icon: 'fas fa-chevron-double-down',
    },
  ],
  TASK_COMPLEXITY: [
    {
      label: '1',
      value: '1',
    },
    {
      label: '2',
      value: '2',
    },
    {
      label: '3',
      value: '3',
    },
    {
      label: '5',
      value: '5',
    },
    {
      label: '8',
      value: '8',
    },
    {
      label: '13',
      value: '13',
    },
  ],
  TASK_FILTER_STATUS: {
    WAIT_CONFIRM: 'wait_confirm',
    PROCESSING: 'processing',
    WAIT_DONE: 'wait_done',
    DONE: 'done',
    DONE_LATE: 'done_late',
    NOT_START: 'not_start',
    UNLIMITED: 'unlimited',
    LATE: 'late',
    IMPORTANT: 'important',
    URGENT: 'urgent',
  },
  LIST_TASK_FILTER_STATUS: [
    {
      label: 'Tất cả',
      value: '',
      icon: 'far fa-list-ul',
    },
    {
      label: 'Chờ duyệt thực hiện',
      value: 'wait_confirm',
      icon: 'far fa-tag',
    },
    {
      label: 'Đang thực hiện',
      value: 'processing',
      icon: 'far fa-tag',
    },
    {
      label: 'Chờ duyệt hoàn thành',
      value: 'wait_done',
      icon: 'far fa-tag',
    },
    {
      label: 'Hoàn thành',
      value: 'done',
      icon: 'far fa-tag',
    },
    {
      label: 'Hoàn thành quá hạn',
      value: 'done_late',
      icon: 'far fa-tag',
    },
    {
      label: 'Chưa có thời hạn',
      value: 'unlimited',
      icon: 'far fa-tag',
    },
    {
      label: 'Quá hạn',
      value: 'late',
      icon: 'far fa-tag',
    },
  ],
  TASK_DISPLAY: [
    {
      label: 'Tất cả',
      value: '',
      icon: 'far fa-list-ul',
    },
    {
      label: 'Công việc chính',
      value: 'task',
      icon: 'far fa-tag',
    },
  ],
  TASK_GROUP: [
    {
      label: 'Thời gian',
      value: '1',
      icon: 'far fa-clock',
    },
    {
      label: 'Người xử lý',
      value: '2',
      icon: 'far fa-user-check',
    },
    {
      label: 'Dự án',
      value: '3',
      icon: 'far fa-file',
    },
    {
      // CongPPT 2026-02-04: Sửa label
      label: 'Đơn vị',
      value: '4',
      icon: 'fas fa-th-large',
    },
    {
      label: 'Nhóm công việc',
      value: '5',
      icon: 'fas fa-layer-group',
    },
  ],
  TASK_FREQUENCY: {
    WEEKLY: 'weekly',
    MONTHLY: 'monthly',
    YEARLY: 'yearly',
  },
  LIST_TASK_FREQUENCY: [
    {
      label: 'Hằng tuần',
      value: 'weekly',
    },
    {
      label: 'Hằng tháng',
      value: 'monthly',
    },
    {
      label: 'Hằng năm',
      value: 'yearly',
    },
  ],
  LIST_WEEK_DAYS: [
    {
      label: 'Chủ nhật',
      value: '0',
    },
    {
      label: 'Thứ 2',
      value: '1',
    },
    {
      label: 'Thứ 3',
      value: '2',
    },
    {
      label: 'Thứ 4',
      value: '3',
    },
    {
      label: 'Thứ 5',
      value: '4',
    },
    {
      label: 'Thứ 6',
      value: '5',
    },
    {
      label: 'Thứ 7',
      value: '6',
    },
  ],
  ROLES_EDITABLE: [
    {
      label: 'Lãnh đạo đơn vị',
      value: 'role-leader',
    },
    {
      label: 'Quản lý đơn vị',
      value: 'role-admin',
    },
    {
      label: 'Thành viên',
      value: 'role-member',
    },
  ],
  ROLES: [
    {
      label: 'Quản trị hệ thống',
      value: 'role-owner',
    },
    {
      label: 'Lãnh đạo đơn vị',
      value: 'role-leader',
    },
    {
      label: 'Quản lý đơn vị',
      value: 'role-admin',
    },
    {
      label: 'Thành viên',
      value: 'role-member',
    },
  ],
  ROLES_KEY: {
    OWNER: 'role-owner',
    LEADER: 'role-leader',
    ADMIN: 'role-admin',
    MEMBER: 'role-member',
  },
  PROJECT_SETTING: [
    {
      label: 'Phê duyệt công việc trong dự án',
      value: 'approval',
    },
    {
      label: 'Tạo mới công việc',
      value: 'new-task',
    },
    {
      label: 'Tạo nhóm công việc mới',
      value: 'new-group-task',
    },
    {
      label: 'Xem công việc toàn bộ dự án',
      value: 'view-all',
    },
    {
      label: 'Gán công việc cho người khác',
      value: 'assign',
    },
    {
      label: 'Xem báo cáo tổng thể',
      value: 'report',
    },
    {
      label: 'Tạo thư mục tài liệu, upload tài liệu',
      value: 'upload-file',
    },
    {
      label: 'Tạo cuộc thảo luận trong dự án',
      value: 'new-group-chat',
    },
    {
      label: 'Chỉ thành viên dự án được phép truy cập',
      value: 'private',
    },
  ],
  PROJECT_SETTING_KEY: {
    APPROVAL: 'approval',
    NEW_TASK: 'new-task',
    NEW_GROUP_TASK: 'new-group-task',
    VIEW_ALL: 'view-all',
    ASSIGN: 'assign',
    REPORT: 'view-report',
    UPLOAD_FILE: 'upload-file',
    NEW_GROUP_CHAT: 'new-group-chat',
    PRIVATE: 'private',
  },
  USERLOG_ACTIONS: [
    {
      label: 'Thêm',
      value: 'created',
    },
    {
      label: 'Sửa',
      value: 'updated',
    },
    {
      label: 'Xóa',
      value: 'deleted',
    },
  ],
  FUNCTIONS_CODE: [
    {
      label: 'Công việc',
      value: 'task',
    },
    {
      label: 'Nhóm thành viên',
      value: 'team',
    },
    {
      label: 'Nhóm quyền',
      value: 'role',
    },
    {
      label: 'Dự án',
      value: 'project',
    },
    {
      label: 'Công việc con',
      value: 'subtask',
    },
  ],
  LIST_FILTER_DATE: [
    {
      title: 'Ngày',
      iconAffter: <IconArrowDown />,
    },
    {
      title: 'Tuần',
      iconAffter: <IconArrowDown />,
    },
    {
      title: 'Tháng',
      iconAffter: <IconArrowDown />,
    },
    {
      title: 'Năm',
      iconAffter: <IconArrowDown />,
    },
  ],
  POSITIONS: [
    {
      label: 'Bộ trưởng Bộ Công an',
      value: 'bo-truong-bo-cong-an',
    },
    {
      label: 'Thứ trưởng Bộ Công an',
      value: 'thu-truong-bo-cong-an',
    },
    {
      label: 'Cục trưởng',
      value: 'cuc-truong',
    },
    {
      label: 'Phó Cục trưởng',
      value: 'pho-cuc-truong',
    },
    {
      label: 'Vụ trưởng',
      value: 'vu-truong',
    },
    {
      label: 'Phó Vụ trưởng',
      value: 'pho-vu-truong',
    },
    {
      label: 'Giám đốc Công an tỉnh/thành phố',
      value: 'giam-doc-cong-an-tinh',
    },
    {
      label: 'Phó Giám đốc Công an tỉnh/thành phố',
      value: 'pho-giam-doc-cong-an-tinh',
    },
    {
      label: 'Trưởng phòng',
      value: 'truong-phong',
    },
    {
      label: 'Phó Trưởng phòng',
      value: 'pho-truong-phong',
    },
    {
      label: 'Trưởng Công an xã/phường/thị trấn',
      value: 'truong-cong-an-xa-phuong-thi-tran',
    },
    {
      label: 'Phó Trưởng Công an xã/phường/thị trấn',
      value: 'pho-truong-cong-an-xa-phuong-thi-tran',
    },
    {
      label: 'Đội trưởng',
      value: 'doi-truong',
    },
    {
      label: 'Phó Đội trưởng',
      value: 'pho-doi-truong',
    },
    {
      label: 'Cán bộ điều tra',
      value: 'can-bo-dieu-tra',
    },
    {
      label: 'Cán bộ nghiệp vụ',
      value: 'can-bo-nghiep-vu',
    },
    {
      label: 'Cảnh sát khu vực',
      value: 'can-bo-canh-sat-khu-vuc',
    },
  ],
  LEVELS: [
    {
      label: 'Chiến sĩ',
      value: 'chien-si',
    },
    {
      label: 'Hạ sĩ',
      value: 'ha-si',
    },
    {
      label: 'Trung sĩ',
      value: 'trung-si',
    },
    {
      label: 'Thượng sĩ',
      value: 'thuong-si',
    },
    {
      label: 'Thiếu úy',
      value: 'thieu-uy',
    },
    {
      label: 'Trung úy',
      value: 'trung-uy',
    },
    {
      label: 'Thượng úy',
      value: 'thuong-uy',
    },
    {
      label: 'Đại úy',
      value: 'dai-uy',
    },
    {
      label: 'Thiếu tá',
      value: 'thieu-ta',
    },
    {
      label: 'Trung tá',
      value: 'trung-ta',
    },
    {
      label: 'Thượng tá',
      value: 'thuong-ta',
    },
    {
      label: 'Đại tá',
      value: 'dai-ta',
    },
    {
      label: 'Thiếu tướng',
      value: 'thieu-tuong',
    },
    {
      label: 'Trung tướng',
      value: 'trung-tuong',
    },
    {
      label: 'Thượng tướng',
      value: 'thuong-tuong',
    },
    {
      label: 'Đại tướng',
      value: 'dai-tuong',
    },
  ],
  DEFAULT_PAGE_SIZE: 10,
  DEFAULT_PAGE_SIZE_V2: 50,
  DEFAULT_PAGE_INDEX: 0,
};

export const DEFAULT_MESSAGE_PROGRESS_SUCCESS =
  'Phê duyệt tiến độ thành công';

export const DEFAULT_REJECT_MESSAGE_PROGRESS_SUCCESS =
  'Từ chối tiến độ thành công';

export default constants;
